import React from 'react'

import CircularProgress from '@pixel/core/CircularProgress'
import Skeleton from '@pixel/core/Skeleton'
import Paper from '@pixel/core/Paper'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { styled } from '@pixel/core/styles'

const ListBaseDefaultLoadingContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})

export const ListBaseDefaultLoading = () => (
    <ListBaseDefaultLoadingContainer>
        <CircularProgress />
    </ListBaseDefaultLoadingContainer>
)

export const ListBaseSkeletonLoading = ({ columns, items }: { columns: Array<string>, items: number }) => (
    <TableContainer component={Paper}>
        <Table>
            <TableHead>
                <TableRow>
                    {columns.map(columnName => (
                        <TableCell key={columnName}>{columnName}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {[...Array(items)].map((item, index) => (
                    <TableRow key={index}>
                        {columns.map((column) => (
                            <TableCell key={column} aria-label={`Skeleton Cell-${index}-${column}`}>
                                <Skeleton variant="rectangular" />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)

export default ListBaseSkeletonLoading
